export default class ActivateBillingAccountRequest{
    
    BillingAddress1 : string = '';
    
    FirstName : string = '';
   
    LastName : string = '';

    Company : string = '';
    
    BillingPostalCode : string = '';
   
    BillingCity : string = '';

    Phone : string = '';
    
    Country : string = '';
   
    StateProv : string = '';

    Email : string = '';
    
    CCFirstName : string = '';
   
    CCLastName : string = '';

    CCNumber : string = '';
    
    ExpMonth : string = '';
   
    ExpYear : string = '';

    CVV : string = '';
}